import {useQuery} from '@tanstack/react-query';
import {
  getCompaniesLatestPressReleasesV2,
  getMediaOnlyCompaniesLatestPressReleases,
} from '../operations/get-companies-latest-press-releases';
import {usePressReleaseQuery} from './use-press-release-query';
import {getItem} from '@/utils/cookies';

/**
 * プレスリリースページで本文下に表示する他のプレスリリースを取得するクエリ
 * 表示しているプレスリリースを除いた、配信企業の最新20件のプレスリリース
 */
export const useLatestPressReleasesQuery = () => {
  const {data: pressRelease} = usePressReleaseQuery();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['latestPressReleases', pressRelease?.companyId],
    async queryFn() {
      if (pressRelease === undefined) {
        return [];
      }

      if (getItem('current_user_type') === 'media_user') {
        const {data: releases} = await getMediaOnlyCompaniesLatestPressReleases(
          pressRelease.companyId,
          21,
        );
        return releases.data
          .filter((release) => release.id !== pressRelease.releaseId)
          .slice(0, 20);
      }

      const {data: releases} = await getCompaniesLatestPressReleasesV2(
        pressRelease.companyId,
        21,
      );

      return releases.data
        .filter((release) => release.id !== pressRelease.releaseId)
        .slice(0, 20);
    },
  });

  return query;
};
